import React, { useState } from 'react';
import {Form, Button, AutoCenter, Toast } from 'antd-mobile';
import { useSearchParams } from 'react-router-dom';
import ImageUploaderH5 from './ImageUploaderH5';
import { useApp_multiple_upload_imageMutation } from '../store/reactapiApi';

function UploadH5() {
    const [form] = Form.useForm();  
    const [param] = useSearchParams()
    const [info,setInfo] = useState({
        itk_token:param.get('token') ,
        itk_image:''
    })
    const [add] = useApp_multiple_upload_imageMutation();
    const [state,setState] = useState()
    return (
        <div>
            {
                state?<AutoCenter>上传成功！</AutoCenter>:<Form
                                                            form={form}                                            
                                                            footer={
                                                                <Button color='primary' block onClick={() => {
                                                                    add(info).then((res) => {
                                                                                console.log(res);
                                                                                if (res.data.Status === 'success') {
                                                                                    Toast.show({
                                                                                        icon: 'success',
                                                                                        content: '保存成功',
                                                                                    });
                                                                                    form.resetFields();
                                                                                    setState('success')
                                                                                }
                                                                                if (res.data.Status === 'fail') {
                                                                                    Toast.show({
                                                                                        icon: 'fail',
                                                                                        content: res.data.Message || '保存失败',
                                                                                    });
                                                                                }
                                                                            })
                                                                }}>提交</Button>
                                                            }
                                                        >
                                                            <Form.Header>选择图片后，点击提交</Form.Header>
                                                            <ImageUploaderH5
                                                                maxCount='20'
                                                                label='图片'
                                                                name='itk_image'
                                                                onChange={(value) => {
                                                                    setInfo(prevState => ({ 
                                                                        ...prevState, 
                                                                        itk_image: value 
                                                                    }));
                                                                }}
                                                            />
                                                        </Form>
            }
        </div>
    );
}

export default UploadH5;